const FilterCollections = {
  mounted() {
    let search_input = document.querySelector(".search-filters-area input");
    let clear_filters = document.querySelector(".clear-filters");
    let filter_public = document.querySelector("#filterPublic");
    let filter_private = document.querySelector("#filterPrivate");
    let filter_favorite = document.querySelector("#filterFavorite");
    let collections = this.el.querySelectorAll(".collection-item");

    function applyFilters() {
      let anyFilterChecked =
        filter_public.checked ||
        filter_private.checked ||
        filter_favorite.checked;
      let query = search_input.value.toLowerCase();
      collections.forEach((collection) => {
        let isPublic = collection.classList.contains("public");
        let isPrivate = collection.classList.contains("private");
        let isFavorite = collection.classList.contains("favorite");
        let title = collection.querySelector("a p").innerText.toLowerCase();

        let showPublic = filter_public.checked && isPublic;
        let showPrivate = filter_private.checked && isPrivate;
        let showFavorite = filter_favorite.checked && isFavorite;

        let matchesSearch = title.includes(query);
        if (
          (!anyFilterChecked || showPublic || showPrivate || showFavorite) &&
          matchesSearch
        ) {
          collection.classList.remove("hidden");
        } else {
          collection.classList.add("hidden");
        }
      });
    }

    filter_public.addEventListener("click", applyFilters);
    filter_private.addEventListener("click", applyFilters);
    filter_favorite.addEventListener("click", applyFilters);

    clear_filters.addEventListener("click", () => {
      search_input.value = "";
      filter_public.setAttribute("checked", false);
      filter_private.setAttribute("checked", false);
      filter_favorite.setAttribute("checked", false);

      collections.forEach((collection) => {
        collection.classList.remove("hidden");
      });
    });

    search_input.addEventListener("input", () => {
      let query = search_input.value.toLowerCase();
      collections.forEach((collection) => {
        let title = collection.querySelector("a p").innerText.toLowerCase();
        collection.classList.toggle("hidden", !title.includes(query));
      });
    });
  },
  destroyed() {
    let search_input = document.querySelector(".search-filters-area input");
    let clear_filters = document.querySelector(".clear-filters");
    let filter_public = document.querySelector("#filterPublic");
    let filter_private = document.querySelector("#filterPrivate");
    let filter_favorite = document.querySelector("#filterFavorite");

    filter_public.removeEventListener("click", this.applyFilters);
    filter_private.removeEventListener("click", this.applyFilters);
    filter_favorite.removeEventListener("click", this.applyFilters);
    clear_filters.removeEventListener("click", this.clearFilters);
    search_input.removeEventListener("input", this.handleSearch);
  }
};

export default FilterCollections;
